import styled from 'styled-components'

import { textSizeM, textSizeS } from '@/styles/theme/fonts.ts'

export const Header1 = styled.h1`
  font-size: 32px;
  font-weight: 500;
  line-height: 36.8px;
  letter-spacing: -0.13px;
`

export const Header2 = styled.h2`
  font-size: 26px;
  line-height: 32px;
  font-weight: 500;
  letter-spacing: -0.13px;
`

export const Header3 = styled.h3`
  font-size: 22px;
  line-height: 28px;
  font-weight: 500;
  letter-spacing: -0.11px;
`

export const Header4 = styled.h4`
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  letter-spacing: 0.36px;
`

type TextProps = {
  fontWeight?: 'bold' | 'normal'
}

export const Text = styled.p<TextProps>`
  ${textSizeM};
  font-weight: ${({ fontWeight }) => (fontWeight === 'bold' ? 500 : 400)};
  color: ${({ color, theme }) => color || theme.colors.common.black75};
`

export const BodyS = styled(Text)`
  ${textSizeS}
`

export const BodyM = styled(Text)``

export const Header = styled(Header1)`
  margin-bottom: 40px;
`

export const Description = styled(Text)`
  margin-top: 16px;
  margin-bottom: 24px;
`

export const Subheader = styled(Header4)`
  display: block;
  margin-bottom: 24px;
`

export const Caption = styled(BodyS)`
  margin-top: 16px;
`
